import type { Appointment, Education, Position } from '~/interfaces/person'

export class About {
  constructor(
    public researchFoci?: Array<string>,
    public education?: Array<Education>,
    public positions?: Array<Position>,
    public appointments?: Array<Appointment>,
  ) {}

  public get researchFociPopulated(): boolean {
    return !!this.researchFoci && this.researchFoci.length > 0
  }

  public get educationPopulated(): boolean {
    return !!this.education && this.education.length > 0
  }

  public get positionsPopulated(): boolean {
    return !!this.positions && this.positions.length > 0
  }

  public get appointmentsPopulated(): boolean {
    return !!this.appointments && this.appointments.length > 0
  }

  public get anyPopulated(): boolean {
    return (
      this.researchFociPopulated ||
      this.educationPopulated ||
      this.positionsPopulated ||
      this.appointmentsPopulated
    )
  }

  toJson(): object {
    return { ...this }
  }
}
